import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import {
  Insurance,
  InsuranceResponse,
  InsurancesResponse,
} from './insurance.model';

@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  readonly http = inject(HttpClient);
  path = 'insurance/insurance';

  private handleError(err: any, error: string) {
    return throwError(() =>
      err.status === 400 ? err.error.msg : `Se ha producido un error: ${error}`
    );
  }

  getList(lang: string = 'es'): Observable<Insurance[]> {
    let params = new HttpParams().set('lang', lang);
    params = params.set('all', false);
    return this.http.get<InsurancesResponse>(`${this.path}`, { params }).pipe(
      map(resp => resp.data),
      catchError(err => this.handleError(err, 'Recuperar elementos'))
    );
  }

  getInsurance(insurance_id: number): Observable<Insurance> {
    return this.http
      .get<InsuranceResponse>(`${this.path}/${insurance_id}`)
      .pipe(
        map(resp => resp.data),
        catchError(err => this.handleError(err, 'Recuperar elemento'))
      );
  }

  // activeInsurance(type: number, id: number): Observable<boolean> {
  //   return this.http
  //     .post<boolean>(`${this.path}/${type}/item/${id}/active`, null)
  //     .pipe(catchError((err) => this.handleError(err, 'Activar elemento')));
  // }

  addInsurance(
    element: Insurance,
    images: { file: File }[]
  ): Observable<Insurance> {
    const formData: FormData = new FormData();

    for (const image of images) {
      image?.file && formData.append('image', image.file, image.file.name);
    }

    formData.append(`insurance`, JSON.stringify(element));

    return this.http
      .post<Insurance>(`${this.path}`, formData)
      .pipe(catchError(err => this.handleError(err, 'Añadir elemento')));
  }

  modifyInsurance(
    element: Insurance,
    images: { file: File }[]
  ): Observable<Insurance> {
    const formData: FormData = new FormData();

    for (const image of images) {
      image?.file && formData.append('image', image.file, image.file.name);
    }

    formData.append(`insurance`, JSON.stringify(element));

    return this.http
      .put<Insurance>(`${this.path}/${element.insurance_id}`, formData)
      .pipe(catchError(err => this.handleError(err, 'Modificar elemento')));
  }

  deleteInsurance(insurance_id: number): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this.path}/${insurance_id}`)
      .pipe(catchError(err => this.handleError(err, 'Eliminar elemento')));
  }
}
